import styled from "styled-components";

const Image = styled.img`
  width: 100px;
  height: 100px;
`;

export default Image;